function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useStore, useStoreActions } from "../contexts";
import { selectors } from "../store/state-selectors";
export function useSetWorksAtOptimisticUpdate() {
  const {
    setWorksAt
  } = useStoreActions();
  const worksAt = useStore(selectors.user.business);
  return (isSampleRelationship, externallySign) => {
    var _worksAt$key;
    if (!worksAt) {
      return;
    }
    const key = isSampleRelationship ? 'numSampleAgreements' : 'numSaleAgreements';
    const {
      pending,
      approved
    } = (_worksAt$key = worksAt[key]) !== null && _worksAt$key !== void 0 ? _worksAt$key : {
      pending: 0,
      approved: 0
    };
    setWorksAt(_objectSpread(_objectSpread({}, worksAt), {}, {
      [key]: {
        pending: externallySign ? pending : pending + 1,
        approved: externallySign ? approved + 1 : approved
      }
    }));
  };
}